<template>
<div> 
  <div v-if="conversations.noconvnofollower">{{ $t('dash.div.noconvnofollower') }} </div>
  <div v-if="conversations.notallowed"> {{ $t('dash.div.notallowed') }} </div>
  <div v-if=" page.network == 'instagram' && conversations.nofb">{{$t('dash.div.nofb')}}</div>
<div class="chats" v-if="conversations">
  <div class="chat-search">
    <input type="text" v-bind:placeholder="$t('dash.placeholder.search')" id="myInput" @keyup="Search">
     <div class="filter">
        <vs-dropdown :vs-trigger-click="true">
          <vs-button class="btn-filter" type="filled" icon="more_horiz"></vs-button>
          <vs-dropdown-menu>
            <vs-dropdown-item @click.prevent="filterInbox" >
              {{$t('dash.button.inbox')}}
            </vs-dropdown-item>
            <vs-dropdown-item @click.prevent="FilterFollow" class="delete-comment">
              {{$t('dash.button.follow')}}
            </vs-dropdown-item>
            <vs-dropdown-item @click.prevent="filterUnread" class="delete-comment">
              {{$t('dash.button.unread')}}
            </vs-dropdown-item>
            <vs-dropdown-item @click.prevent="filterDone" class="delete-comment">
              {{$t('dash.button.done')}}
            </vs-dropdown-item>
               <vs-dropdown-item @click.prevent="filterSpam" class="delete-comment">
              {{$t('dash.button.spam')}}
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
  </div>
  <div class="conversation-ul scrollable">
    <ul id="myUl">
        <li v-for="(conversation, key) in conversations.data" 
          :key="key" 
           
        > 
          
            <div class="chat" v-if="conversation &&  conversation.participants.data[0].name && conversation.id" id="chatindex" tabindex="0" @click.prevent="showDiscussion(conversation.id,conversation.participants.data[getInstagram].id)">
                <div class="chat-image"> 
                  <img class="chat-image" v-if="listUser && listUser[key] && listUser[key].body && listUser[key].body.user && listUser[key].body.user.picture" :src="listUser[key].body.user.picture.data.url" />
                  <!--<img v-else src="ton-image-par-defaut.jpg" />-->
                </div>
                <div class="chat-content">
                    <div class="chat-content-name" href="#" :class="{'new-message': conversation.unread_count > 0}">
                        {{ conversation.participants.data[0].name }}
                      <!--  <button class="chat-content-button-done"    @click="conversationDone"><img src="../../assets/img/icon_validate_white.svg" title="Déplacé vers le dossier terminé"></button>-->
                    </div>
                    <div class="chat-content-post">
                            <div v-if="page.network == 'facebook'" class="chat-content-post-message" :class="{'new-message': conversation > 0}">
                                {{ sliceSnippet(conversation.snippet) }}
                            </div>
                            <div class="chat-content-post-date">
                                {{ dateFromNow(conversation.updated_time)}}
                            </div>
                    </div>
                </div>
            </div> 
        </li>
     </ul>
    <div class="pagination-posts next-post" v-if="conversations.paging && conversations.paging.next && conversations.data[29]">
      <vs-button class="page-btn btn-large" @click="paginationConversations('next')" vs-type="filled">
        {{ $t("dash.moderation.next-conversations")}}
      </vs-button>
    </div>
  </div>
</div>
</div>


 
</template>

<script>
import moment from 'moment'
import Moderation from './../mixins/Moderation'



export default {
  name: 'component-conversations',

  mixins: [Moderation],

  components: {

  },

  props: {
    page: Object,
    refreshdicussion: Object,
    conversationsFromModeration: Object,

  },
 
  data() {
    return {
      conversations: null,
      listUser : [],
    }
  },

 async mounted(){
    console.log('je suis dans conversations.vue')
    console.log(this.page)
    console.log('convfrommoderation', this.conversationsFromModeration)
    if(this.conversationsFromModeration == null){
    let response = await this.getConversations(this.page)
    console.log(1, response)
    this.conversations = response.body.conversations
    }
    else{
      this.conversations = this.conversationsFromModeration
    }
    console.log('conversations', this.conversations)
    console.log('typeof conversations', typeof this.conversations)
    let listId= []
    if(this.page.network != 'instagram'){
    for (let index = 0; index < this.conversations.data.length; index++) {
      listId.push(this.conversations.data[index].participants.data[0].id)
      
    }
    }
    if(this.page.network == 'instagram'){
     for (let index = 0; index < this.conversations.data.length; index++) {
      listId.push(this.conversations.data[index].participants.data[1].id)
      
    }
    }
    console.log('liste des iduser conversation',listId)
    console.log('typeof listId:', typeof listId)

      for (var id of Object.values(listId))
      {
        let response = await this.getUser(this.page,id)
        this.listUser.push(response)

      }

   // this.listUser = await this.getUsers(listId)
    
    console.log('user',this.listUser) 

    //console.log('picture:',this.listUser[0].body.user.picture.data.url)
    //console.log(2, this.conversations.data)
  //  console.log('conversation senders',this.conversations.data[1].senders.data)
    //console.log('conversation participants',this.conversations.data[0].participants.data)
  },

  methods: {
   /** async getUsers(listId){
      console.log('get user ici la  listId', listId, typeof listId)
      let listUser=[]
      for (var id of Object.values(listId))
      {
        let response = await this.getUser(this.page,id)
        listUser.push(response)

      }
      console.log('list User getUser method :', listUser)
      return listUser
},*/
    async Search(){
    console.log('je suis dans search conversation.vue')
   /**Code pour avoir la recherche filtre en requete a facebook console.log(this.page)
    let response = await this.getConversationsByName(this.page)
    console.log(1, response)
    this.conversations = response.body.conversations
    let listId= []
    for (let index = 0; index < this.conversations.data.length; index++) {
      listId.push(this.conversations.data[index].participants.data[0].id)
      
    }
    console.log('liste des iduser conversation done:',listId)
    console.log('typeof listId:', typeof listId)

    this.listUser = await this.getUsers(listId)
    
    console.log('user',this.listUser) 

    console.log('picture:',this.listUser[0].body.user.picture.data.url) */
      var input, filter , ul, li , a , i , txtValue
      input = document.getElementById('myInput')
      filter= input.value.toUpperCase();
      ul = document.getElementById('myUl')
      li = ul.getElementsByTagName('li');



      for(i=0; i<li.length; i++){
        a =  li[i].getElementsByClassName('chat-content-name')[0]
        txtValue = a.textContent || a.innerText
        if(txtValue.toUpperCase().indexOf(filter) > -1){
          li[i].style.display =""
        }
        else{
          li[i].style.display = "none"
        }

      }
    },
    filterUnread(){
       var input, filter , ul, li , a , i , txtValue
      input = document.getElementById('myInput')
      let ind = 0
      let unreaded = []
      for(const conv of this.conversations.data){
        console.log(conv.unread_count)
        if(conv.unread_count != 0){
          unreaded.push(this.conversations.data[ind])
        }
        ind++        
      }
      console.log('conversation',this.conversations.data)
      console.log('unread',unreaded)
      this.conversations.data = unreaded
    },

    paginationConversations(type='next'){

      let link = type == 'next' 
                  ? this.conversations.paging.next
                  : this.conversations.paging.previous

      this.$vs.loading({
        //background: 'primary',
        color: 'primary'
      })

      this.getPreviousNextNodePageFromRS(link).then(async res => {
        this.$vs.loading.close()
        
        console.log('resMore', res)
        this.$set(this.conversations, 'data', this.conversations.data.concat(res.body.data))
        this.$set(this.conversations, 'paging', res.body.paging ? res.body.paging : null)

         let listId= []
        for (let index = 0; index < this.conversations.data.length; index++) {
          listId.push(this.conversations.data[index].participants.data[0].id)
          
        }
        console.log('liste des iduser conversation follow:',listId)
        console.log('typeof listId:', typeof listId)

          for (var id of Object.values(listId))
      {
        let response = await this.getUser(this.page,id)
        this.listUser.push(response)

      }
        
        console.log('user',this.listUser) 

        //console.log('picture:',this.listUser[0].body.user.picture.data.url)

      })
    },

    getParticipants(){
      this.$emit('getParticipants',this.conversations.data[0].participants.data)
    },
    showDiscussion(conversationid, conversationuserid){
      console.log('showdiscussion conversation:',conversationid, conversationuserid)
      this.$emit('showDiscussion',conversationid, conversationuserid)
    },
    sliceSnippet(snippet)
    {
      if (snippet.length > 25) {
        snippet = snippet.substring(0, 25) + "..";}
      return snippet
    },

    dateFromNow(date){
      return moment(date).fromNow()
    },
    async filterDone(){
    console.log('je suis dans filterDone conversation.vue')
    console.log(this.page)
    let response = await this.getDoneConversations(this.page)
    console.log(1, response)
    this.conversations = response.body.conversations
    let listId= []
    this.listUser = []
    for (let index = 0; index < this.conversations.data.length; index++) {
      listId.push(this.conversations.data[index].participants.data[0].id)
      
    }
    console.log('liste des iduser conversation done:',listId)
    console.log('typeof listId:', typeof listId)

   
    for (var id of Object.values(listId))
      {
        let response = await this.getUser(this.page,id)
        this.listUser.push(response)

      }
        
    console.log('user',this.listUser) 

    // console.log('picture:',this.listUser[0].body.user.picture.data.url)
    },
    async filterInbox(){
      console.log('je suis dans filterinbox conversation.vue')
    console.log(this.page)
    let response = await this.getConversations(this.page)
    console.log(1, response)
    this.conversations = response.body.conversations
    let listId= []
    this.listUser = []
    for (let index = 0; index < this.conversations.data.length; index++) {
      listId.push(this.conversations.data[index].participants.data[0].id)
      
    }
    console.log('liste des iduser conversation spam:',listId)
    console.log('typeof listId:', typeof listId)

    for (var id of Object.values(listId))
      {
        let response = await this.getUser(this.page,id)
        this.listUser.push(response)

      }    
    console.log('user',this.listUser) 

    // console.log('picture:',this.listUser[0].body.user.picture.data.url)

    },

    async filterSpam(){
    console.log('je suis dans filterSpam conversation.vue')
    console.log(this.page)
    let response = await this.getSpamConversations(this.page)
    console.log(1, response)
    this.conversations = response.body.conversations
    let listId= []
    this.listUser= []
    for (let index = 0; index < this.conversations.data.length; index++) {
      listId.push(this.conversations.data[index].participants.data[0].id)
      
    }
    console.log('liste des iduser conversation spam:',listId)
    console.log('typeof listId:', typeof listId)

    for (var id of Object.values(listId))
      {
        let response = await this.getUser(this.page,id)
        this.listUser.push(response)

      }    
    
    console.log('user',this.listUser) 

    // console.log('picture:',this.listUser[0].body.user.picture.data.url)
    },

    async FilterFollow(){
    console.log('je suis dans filterFollow conversation.vue')
    console.log(this.page)
    let response = await this.getFollowConversations(this.page)
    console.log(1, response)
    this.conversations = response.body.conversations
    let listId= []
    this.listUser= []
    for (let index = 0; index < this.conversations.data.length; index++) {
      listId.push(this.conversations.data[index].participants.data[0].id)
      
    }
    console.log('liste des iduser conversation follow:',listId)
    console.log('typeof listId:', typeof listId)

    for (var id of Object.values(listId))
      {
        let response = await this.getUser(this.page,id)
        this.listUser.push(response)

      }    
    
    console.log('user',this.listUser) 

    // console.log('picture:',this.listUser[0].body.user.picture.data.url)
    },

    conversationDone(){

    },

    dateFormat(date){
      return moment(date).local(this.$i18n.locale).format('LLL')
    },
  
  //  async getConv(){
  //    console.log('entrer dans getConversations moderation',this.pagesActive[this.selectedTab])
  //    let status = await this.getConversations(this.pagesActive[this.selectedTab])
  //  },

  },
  computed: {
     getInstagram()  {
     if(this.page.network == 'instagram')
     return 1
     else
     return 0
   },
   
      /**
       * 
       
   getCountLikes() {
     return this.comment.like_count && this.comment.like_count > 0 ? `(${this.comment.like_count})` : ""
   },
   
   has_liked(){
     return this.comment && this.comment.likes && this.comment.likes.data && this.comment.likes.data.find(liker => liker.id == this.page.network_id) 
              ? true
              : false
   }
   */
  },

  watch: {
    conversationsFromModeration: function() {
      this.conversations = this.conversationsFromModeration
    },

    page: async function(){
    console.log('je suis dans watch page conversation.vue')
    this.conversations = null
    console.log(this.page)
    let response = await this.getConversations(this.page)
    console.log(1, response)
    this.conversations = response.body.conversations
    console.log('conversations', this.conversations)
    let listId= []
    for (let index = 0; index < this.conversations.data.length; index++) {
      listId.push(this.conversations.data[index].participants.data[0].id)
      
    }
    console.log('liste des iduser conversation',listId)
    console.log('typeof listId:', typeof listId)

     this.listUser=[]
      for (var id of Object.values(listId))
      {
        let response = await this.getUser(this.page,id)
        this.listUser.push(response)

      }
    
    console.log('user',this.listUser) 

    // console.log('picture:',this.listUser[0].body.user.picture.data.url)
    //console.log(2, this.conversations.data)
  //  console.log('conversation senders',this.conversations.data[1].senders.data)
    //console.log('conversation participants',this.conversations.data[0].participants.data)
    },
    refreshdicussion: async function(){
      console.log('je suis dans watch page conversation.vue')
    this.conversations = null
    console.log(this.page)
    let response = await this.getConversations(this.page)
    console.log(1, response)
    this.conversations = response.body.conversations
    console.log('conversations', this.conversations)
    let listId= []
    for (let index = 0; index < this.conversations.data.length; index++) {
      listId.push(this.conversations.data[index].participants.data[0].id)
      
    }
    console.log('liste des iduser conversation',listId)
    console.log('typeof listId:', typeof listId)

    this.listUser=[]
      for (var id of Object.values(listId))
      {
        let response = await this.getUser(this.page,id)
        this.listUser.push(response)

      }
    
    console.log('user',this.listUser) 

    // console.log('picture:',this.listUser[0].body.user.picture.data.url)
    },
  }
}    
</script>